<template>
  <!-- 会员投注 -->
  <a-layout-content>
    <div>
      <a-form layout="inline">
        <a-form-item label="会员账号">
          <a-input v-model="userid" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="search()">搜索</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="showexport()">批量导出</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="allExport()" v-if="role102">导出全部</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="payoutExport()" v-if="role102">导出派彩</a-button>
        </a-form-item>
        <a-form-item v-if="role102">
          <a-button type="primary" @click="showVipExport()">导出VIP等级</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="danger" @click="checkDelete()" v-if="role33">勾选删除</a-button>
        </a-form-item>
        <a-form-item v-if="role33">
          <a-button type="danger" @click="AllDelete()">删除所有</a-button>
        </a-form-item>
        <a-form-item v-if="role101">
          <a-button type="primary" class="marr10" @click="anewTotal(3)">计算统计</a-button>
          <span class="red">计算统计,将所有会员重新统计</span>
        </a-form-item>
      </a-form>
    </div>
    <br />
    <a-table size="middle" :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }" :columns="columns" row-key="UserID" :data-source="data" :pagination="false" :loading="loading" bordered>
      <template slot="iscalc" slot-scope="text">
        <span v-if="text === 0" color="red">否</span>
        <span v-if="text === 1" color="green">是</span>
      </template>
    </a-table>
    <div style="margin: 16px 0; height: 8px">
      <a-pagination style="float: right" show-size-changer :default-current="pagination.current"
        :total="pagination.total" :show-total="total => `共 ${total} 条`" :pageSizeOptions="pagination.sizeList"
        @change="pageNumberChange" @showSizeChange="sizeChange" />
    </div>

    <!-- 对话框 --------------------------------------------------------------------------------------------------------->
    <a-modal v-model="vipExportViews" title="导出VIP等级" @ok="vipExportConfirm" :width="360">
      <div style="padding: 4px 0;">
        <div style="font-size: 16px; font-weight: bold; margin-bottom: 10px;">VIP等级</div>
        <div style="display: flex; align-items: center;">
          <span style="white-space: nowrap; margin-right: 8px;">等级范围：</span>
          <a-input v-model="slevel" style="width: 110px" />
          <span style="margin: 0 8px;">~</span>
          <a-input v-model="elevel" style="width: 110px" />
        </div>
      </div>
    </a-modal>
    <!-- 对话框 --------------------------------------------------------------------------------------------------------->
    <a-modal v-model="exportviews" title="导出" @ok="exportData2">
      <a-form-model>
        <a-form-model-item label="指定导出页数">
          <a-input v-model="exportpage" />
        </a-form-model-item>
        <a-form-model-item label="设定每页最大笔数">
          <a-input v-model="exportpagesize" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 对话框 --------------------------------------------------------------------------------------------------------->
  </a-layout-content>
</template>
<script>
  import moment from "moment";
  export default {
    data() {
      return {
        /*** 权限
                    32	会员统计查询
                    33	会员统计批量删除
                    34	会员统计删除所有
                    101	会员统计从头计算
                    102	会员统计导出
                   */
        role32: false,
        rol33: false,
        role34: false,
        role101: false,
        role102: false,
        userid: undefined,
        data: [],
        columns: [
          {
            title: "编号",
            dataIndex: "ID",
            align: "center"
          },
          {
            title: "会员帐号",
            dataIndex: "UserID",
            align: "center"
          },
          {
            title: "VIP等级",
            dataIndex: "Level",
            align: "center"
          },
          {
            title: "总有效投注额",
            dataIndex: "BetTotal",
            align: "center"
          },
          {
            title: "周俸禄",
            dataIndex: "WeekBonus",
            align: "center"
          },
          {
            title: "月俸禄",
            dataIndex: "MonthBonus",
            align: "center"
          }
        ],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          sizeList: ["10", "50", "500", "1000", "10000"]
        },
        selectedRowKeys: [],
        loading: false,
        type: 1,
        listQuery: {},
        exportviews: false,
        exportpage: 1,
        exportpagesize: 10,
        vipExportViews: false,
        slevel: 0,
        elevel: 0
      };
    },
    methods: {
      moment,
      //分页页数的改变
      pageNumberChange(current, size) {
        this.pagination.current = current;
        this.pagination.pageSize = size;
        this.qryListAPI();
      },
      //  分页显示条数的变化
      sizeChange(current, size) {
        this.pagination.current = current;
        this.pagination.pageSize = size;
        this.qryListAPI();
      },
      search() {
        this.pagination.current = 1;
        this.qryListAPI();
      },
      // 导出全部
      allExport() {
        const that = this;
        this.$confirm({
          title: "导出",
          content: "确定要导出全部数据吗？",
          onOk() {
            that.exportData(0);
          }
        });
      },
      // 导出派彩
      payoutExport() {
        const that = this;
        this.$confirm({
          title: "导出",
          content: "确定要导出含有彩金的数据吗？",
          onOk() {
            that.exportData(1);
          }
        });
      },

      showVipExport() {
        this.vipExportViews = true;
      },
      vipExportConfirm() {
        this.exportData(2);
        this.vipExportViews = false;
        this.slevel = 0;
        this.elevel = 0;
      },
      //导出
      exportData(viptype) {
        let today = new Date();
        this.$message.success(
          "开始执行导出请在停留在页面勿离开,因数据量较多请稍待片刻谢谢"
        );

        this.axios({
          url: "/userbet/exportuserstatistics",
          method: "get",
          params: {
            UserID: this.userid == undefined ? "" : this.userid,
            Type: this.type,
            Level: viptype,
            Slevel: this.slevel,
            Elevel: this.elevel
          },
          responseType: "blob"
        }).then(response => {
          console.log(response);
          let blob = new Blob([response.data], {
            type: response.data.type
          });
          // 针对于 IE 浏览器的处理, 因部分 IE 浏览器不支持 createObjectURL
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // 创建下载的链接
            downloadElement.href = href;
            downloadElement.download =
              "会员统计- " + today.toISOString().split("T")[0]; // 下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); // 点击下载
            document.body.removeChild(downloadElement); // 下载完成移除元素
            window.URL.revokeObjectURL(href); // 释放掉 blob 对象
          }
        });
      },

      showexport() {
        this.exportviews = true;
      },

      //导出
      exportData2(viptype) {
        let today = new Date();
        this.$message.success(
          "开始执行导出请在停留在页面勿离开,因数据量较多请稍待片刻谢谢"
        );

        this.axios({
          url: "/userbet/exportuserstatistics2",
          method: "get",
          params: {
            UserID: "",
            Type: this.type,
            page: this.exportpage,
            pagesize: this.exportpagesize
          },
          responseType: "blob"
        }).then(response => {
          let blob = new Blob([response.data], {
            type: response.data.type
          });
          // 针对于 IE 浏览器的处理, 因部分 IE 浏览器不支持 createObjectURL
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // 创建下载的链接
            downloadElement.href = href;
            downloadElement.download =
              "会员统计- " + today.toISOString().split("T")[0]; // 下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); // 点击下载
            document.body.removeChild(downloadElement); // 下载完成移除元素
            window.URL.revokeObjectURL(href); // 释放掉 blob 对象
          }
        });
        this.exportviews = false;
      },

      // 勾选删除
      checkDelete() {
        if (this.selectedRowKeys.length < 1) {
          this.$message.warning("请勾选数据");
          return;
        }
        const that = this;
        this.$confirm({
          title: "批量删除",
          content:
            "警告!!您确定要删除您选择的会员统计?,此删除后将会将选择的会员投注,与统计资料作清除!!",
          onOk() {
            const idList = [];
            that.selectedRowKeys.forEach(element => {
              idList.push({
                ID: element
              });
            });
            that.axios
              .post("/userbet/deleteuserstatistics", {
                Type: that.type,
                IDList: idList
              })
              .then(res => {
                if (res.data) {
                  that.$message.success("批量勾选删除成功!");
                  that.qryListAPI();
                }
              });
          }
        });
      },
      // 删除所有
      AllDelete() {
        const that = this;
        this.$confirm({
          title: "删除全部",
          content:
            "警告!!您确定要删除所有会员统计?,此删除后将会将所有会员投注,与统计资料作清除!!",
          onOk() {
            that.axios
              .post("/userbet/alldeleteuserstatistics", {
                Type: that.type
              })
              .then(res => {
                if (res.data) {
                  that.$message.success("全部删除成功!");
                  that.qryListAPI();
                }
              });
          }
        });
      }, // 从头计算
      anewTotal(caltype) {
        let msg = "统计会员数据吗";

        const that = this;
        this.$confirm({
          title: msg,
          content: "您确定" + msg + "？",
          onOk() {
            that.axios
              .post("/userbet/caluserbet", {
                Type: that.type,
                CalType: caltype,
                TermID: 0
              })
              .then(res => {
                if (res.data) {
                  that.$message.success(
                    "已提交服务计算,可至会员计算进度列表查询"
                  );
                  that.qryListAPI();
                }
              });
          }
        });
      },
      // 查询API
      qryListAPI() {
        this.loading = true;
        this.axios
          .post("/userbet/getuserstatistics", {
            UserID: this.userid == undefined ? "" : this.userid,
            Type: this.type,
            pageindex: this.pagination.current,
            pagesize: this.pagination.pageSize
          })
          .then(res => {
            if (res.data) {
              this.pagination.total = res.total;
              this.loading = false;
              this.data = res.data;
            }
          });
      },
      onSelectChange(selectedRowKeys) {
        this.selectedRowKeys = selectedRowKeys;
      }
    },
    //首次加载
    created() {
      this.qryListAPI();
      //获取权限
      const array = JSON.parse(sessionStorage.RoleID);
      const roleID = [32, 33, 34, 101, 102];
      var isRole = roleID.filter(function (item) {
        return array.indexOf(item) != -1;
      });
      //功能权限获取
      isRole.forEach(element => {
        this["role" + element] = true;
      });
    }
  };
</script>

<style>
  .red {
    color: rgb(255, 0, 0);
  }

  .marr10 {
    margin-right: 10px;
    background-color: green;
  }
</style>


// WEBPACK FOOTER //
// src/components/slotleaderboard/usertotal.vue